import { render, staticRenderFns } from "./reg-info.vue?vue&type=template&id=5e29eddc&scoped=true"
import script from "./reg-info.vue?vue&type=script&lang=js"
export * from "./reg-info.vue?vue&type=script&lang=js"
import style0 from "./reg-info.vue?vue&type=style&index=0&id=5e29eddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e29eddc",
  null
  
)

export default component.exports